import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { withRouter } from "react-router-dom";
import NavigationContext from "../../context/navigation/NavigationContext";
import ConfigContext from "../../context/config/ConfigContext";
import NumberFormat from "react-number-format";
import { getStateList } from "../../utils/Lookup";

const Address = (props) => {
  const navigationContext = useContext(NavigationContext);
  const { setFieldRefs } = navigationContext;
  const configContext = useContext(ConfigContext);

  const { getConfigValueByName } = configContext;

  const { address1, address2, city, state, zipcode, phonenumber } =
    props.address;
  const { addressChange, onBlur, phoneNoChange } = props;
  const address1Ref = useRef(null);
  const address2Ref = useRef(null);
  const cityRef = useRef(null);
  const stateRef = useRef(null);
  const zipcodeRef = useRef(null);
  const phonenumberRef = useRef(null);

  const [labels, setLabels] = useState({
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipcode: "",
    phonenumber: "",
  });

  const stateList = getStateList();

  useEffect(() => {
    setFieldRefs({
      address: {
        address1: address1Ref,
        address2: address2Ref,
        city: cityRef,
        state: stateRef,
        zipcode: zipcodeRef,
        phonenumber: phonenumberRef,
      },
    });
    let address1 = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.address1"
    );
    let address2 = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.address2"
    );
    let city = getConfigValueByName("generalConfig", "Label", "label.city");
    let state = getConfigValueByName("generalConfig", "Label", "label.state");
    let zipcode = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.zipcode"
    );
    let phonenumber = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.phonenumber"
    );
    setLabels({
      ...labels,
      address1,
      address2,
      city,
      state,
      zipcode,
      phonenumber,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <div id="address" className="address__formBody">
        {props.title && (
          <div className="billing__cardList__addressSection__title">
            {props.title}
          </div>
        )}
        <form noValidate>
          <div className="address__formBody__formGroup">
            <label htmlFor="address1">
              {labels.address1}
              <span className="required" aria-label="Input required">
                (*Required)
              </span>
              :{" "}
            </label>
            <input
              type="text"
              name="address1"
              id="address1"
              className="form-control"
              onChange={addressChange}
              placeholder={labels.address1}
              value={address1}
              ref={address1Ref}
              onBlur={onBlur}
            />
          </div>
          <div className="address__formBody__formGroup">
            <label htmlFor="address2">{labels.address2} : </label>
            <input
              type="text"
              name="address2"
              id="address2"
              className="form-control"
              onChange={addressChange}
              placeholder={labels.address2}
              value={address2}
              ref={address2Ref}
              onBlur={onBlur}
            />
          </div>
          <div className="address__formBody__formGroup">
            <label htmlFor="city">
              {labels.city}
              <span className="required" aria-label="Input required">
                (*Required)
              </span>
              :{" "}
            </label>
            <input
              type="text"
              name="city"
              id="city"
              className="form-control"
              onChange={addressChange}
              placeholder={labels.city}
              value={city}
              ref={cityRef}
              onBlur={onBlur}
            />
          </div>
          <div className="address__formBody__formGroup">
            <label htmlFor="state">
              {labels.state}
              <span className="required" aria-label="Input required">
                (*Required)
              </span>
              :{" "}
            </label>
            <select
              name="state"
              id="state"
              className="form-control"
              onChange={addressChange}
              placeholder={labels.state}
              value={state}
              ref={stateRef}
              onBlur={(e) => onBlur(e, labels.state)}
            >
              <option value="">--Select--</option>
              {stateList.length > 0 &&
                stateList.map((ele) => (
                  <option value={ele.code} key={ele.code}>
                    {ele.state}
                  </option>
                ))}
            </select>
          </div>
          <div className="address__formBody__formGroup">
            <label htmlFor="zipcode">
              {labels.zipcode}
              <span className="required" aria-label="Input required">
                (*Required)
              </span>
              :{" "}
            </label>
            <input
              type="text"
              name="zipcode"
              id="zipcode"
              maxLength="5"
              className="form-control"
              onChange={addressChange}
              placeholder={labels.zipcode}
              value={zipcode}
              ref={zipcodeRef}
              onBlur={onBlur}
            />
          </div>
          <div className="address__formBody__formGroup">
            <label htmlFor="phonenumber">
              {labels.phonenumber}
              <span className="required" aria-label="Input required">
                (*Required)
              </span>
              :{" "}
            </label>
            <NumberFormat
              name="phonenumber"
              id="phonenumber"
              className="form-control"
              onValueChange={(values) => {
                phoneNoChange(values.value, values.floatValue);
              }}
              placeholder={labels.phonenumber}
              value={phonenumber}
              getInputRef={phonenumberRef}
              onBlur={(e) => onBlur(e, labels.phonenumber)}
              format="+1 ### ### ####"
            />
          </div>
        </form>
      </div>
    </Fragment>
  );
};

export default withRouter(Address);
